import { API } from "aws-amplify";
import { updatePayment as updatePaymentMut } from "../graphql/mutations";
import { GraphQLQuery } from "@aws-amplify/api";
import {
    UpdatePaymentInput,
    UpdatePaymentMutation,
} from "../API";
import { useCallback } from "react";

export function useUpdatePayment() {
    const updatePayment = useCallback(
        async (
            input: UpdatePaymentInput
        ): Promise<boolean | null> => {
            const result = await API.graphql<
                GraphQLQuery<UpdatePaymentMutation>
            >({
                query: updatePaymentMut,
                variables: { input },
            });

            return result.data?.updatePayment || null;
        },
        []
    );

    return { updatePayment };
}
